import { components } from '@api/play-account/generated';
import { components as publicComponents } from '@api/play-public/generated';
import { startOfYesterday, subDays } from 'date-fns';
import { addHours } from 'date-fns/addHours';

import { FEN_SPECIAL_DRAW, FEN_SPECIAL_WHITE_WIN } from '@libs/chess/constants';

import { User } from '@features/auth/services/AuthService';
import {
  ClubGroup,
  ParticipantGameMovementRow,
  MemberDto,
  MemberTournamentParticipantDto,
  ResultsTableAdditionalScore,
  ResultsTableData,
  ResultsGame,
  ResultsTableParticipant,
  ResultsTableRound,
  Tournament,
  KnockoutResults,
  KnockoutResultsMatch,
  KnockoutResultsPlayer,
  MyClubStatsType,
  NewsPost,
  Winner,
  TopPlayer,
  MemberClubDto,
  Sponsor,
  PlayerStats,
  PlayerEloStats,
  ChartPoint,
  Achievement,
} from '@features/shared/api/typings';

export const participantGroups: ClubGroup[] = [
  {
    id: 1,
    title: 'Юность Москвы',
    participantIds: [1, 2, 3],
  },
  {
    id: 2,
    title: 'Старость Омской Области',
    participantIds: [4, 5, 6],
  },
  {
    id: 3,
    title: 'Воронежский Кризис Среднего Возраста',
    participantIds: [7, 8, 9],
  },
];

export const members: MemberDto[] = [
  {
    userId: '1',
    firstName: 'Константин',
    lastName: 'Константинопольский',
    title: 'IG',
    email: 'kostya@test.ru',
    rcfId: '314159265',
    status: 'Active',
    joinTimestampMs: 123123,
    tournamentsCount: 0,
    gamesCount: 0,
    rcfIdApproved: false,
    birthdayTimestampMs: null,
    coachName: null,
    rcfElo: {
      blitz: 1044,
      rapid: 1000,
      classic: 1000,
    },
    elo: {
      blitz: {
        clockControl: 'Blitz',
        gamesCount: 15,
        rating: 2412,
        lastChange: 123,
      },
      rapid: {
        clockControl: 'Rapid',
        gamesCount: 15,
        lastChange: 123,
        rating: 1532,
      },
      classic: {
        clockControl: 'Classic',
        gamesCount: 15,
        lastChange: 123,
        rating: 1111,
      },
    },
    clubElo: {
      blitz: {
        clockControl: 'Blitz',
        gamesCount: 15,
        rating: 2412,
        lastChange: 123,
      },
      rapid: {
        clockControl: 'Rapid',
        gamesCount: 15,
        lastChange: 123,
        rating: 1532,
      },
      classic: {
        clockControl: 'Classic',
        gamesCount: 15,
        lastChange: 123,
        rating: 1111,
      },
    },
    groupName: 'МГИМО',
  },
  {
    userId: '2',
    firstName: 'Иван',
    lastName: 'Петров',
    title: 'GM',
    rcfId: '123',
    email: 'ivan@test.ru',
    status: 'Active',
    joinTimestampMs: 123123,
    tournamentsCount: 12,
    gamesCount: 9999,
    rcfIdApproved: false,
    birthdayTimestampMs: null,
    coachName: null,
    rcfElo: {
      blitz: 1044,
      rapid: 1000,
      classic: 1000,
    },
    elo: {
      blitz: {
        clockControl: 'Blitz',
        gamesCount: 15,
        rating: 1996,
        lastChange: 123,
      },
      rapid: {
        clockControl: 'Rapid',
        gamesCount: 15,
        lastChange: 123,
        rating: 1840,
      },
      classic: {
        clockControl: 'Classic',
        gamesCount: 15,
        lastChange: 123,
        rating: 2000,
      },
    },
    clubElo: {
      blitz: {
        clockControl: 'Blitz',
        gamesCount: 15,
        rating: 1996,
        lastChange: 123,
      },
      rapid: {
        clockControl: 'Rapid',
        gamesCount: 15,
        lastChange: 123,
        rating: 1840,
      },
      classic: {
        clockControl: 'Classic',
        gamesCount: 15,
        lastChange: 123,
        rating: 2000,
      },
    },
    groupName: 'ВГУ',
  },
  {
    userId: '3',
    firstName: 'Магнус',
    lastName: 'Степанович Курский',
    title: 'FM',
    email: 'magnus@test.ru',
    rcfId: '92653589',
    status: 'Active',
    joinTimestampMs: 123123,
    tournamentsCount: 9999,
    gamesCount: 9999,
    rcfIdApproved: false,
    birthdayTimestampMs: null,
    coachName: null,
    rcfElo: {
      blitz: 1044,
      rapid: 1000,
      classic: 1000,
    },
    elo: {
      blitz: {
        clockControl: 'Blitz',
        gamesCount: 15,
        rating: 2412,
        lastChange: 123,
      },
      rapid: {
        clockControl: 'Rapid',
        gamesCount: 15,
        lastChange: 123,
        rating: 1622,
      },
      classic: {
        clockControl: 'Classic',
        gamesCount: 15,
        lastChange: 123,
        rating: 3000,
      },
    },
    clubElo: {
      blitz: {
        clockControl: 'Blitz',
        gamesCount: 15,
        rating: 2412,
        lastChange: 123,
      },
      rapid: {
        clockControl: 'Rapid',
        gamesCount: 15,
        lastChange: 123,
        rating: 1622,
      },
      classic: {
        clockControl: 'Classic',
        gamesCount: 15,
        lastChange: 123,
        rating: 3000,
      },
    },
    groupName: null,
  },
];

export const memberTournamentParticipants: MemberTournamentParticipantDto[] = members.map((p) => ({
  ...p,
  effectiveRating: 1000,
  participationStatus: 'Participating',
}));

export const gameEvents: Tournament[] = [
  {
    clubId: '200',
    tournamentId: '1',
    title: 'Отборочный турнир отдела закупок',
    status: 'InProgress',
    system: 'Swiss',
    swissSettings: {
      roundsCount: 2,
    },
    customRoundDelays: [{ roundNumberAfter: 1, delaySeconds: 30 }],
    logoUrl: 'https://upload.wikimedia.org/wikipedia/ru/2/2d/Gazprom-Logo-rus.svg',
    entrance: 'Invite',
    registrationClosedBeforeStartMinutes: null,
    participantPreModerationEnabled: false,
    rcfRankCalculated: true,
    highlight: 'None',
    mode: 'Private',
    clockControl: 'Blitz',
    teamsCount: 64,
    teamsCountMax: 64,
    participantsCountMax: 512,
    clockControlSettingsPlayer1: {
      initialSeconds: 5,
      addSecondsPerMove: 3,
    },
    clockControlSettingsPlayer2: {
      initialSeconds: 5,
      addSecondsPerMove: 3,
    },
    additionalScoreOrder: [],
    rulesUrl: '',
    contacts: [
      {
        name: 'Судья',
        label: 'Константин Константинопольский',
        uri: 'http://tg.me/kost',
      },
    ],
    startTimestampMs: addHours(Date.now(), -1).getTime(),
    rounds: [
      {
        roundId: '1',
        roundNumber: 1,
        cycleNumber: 1,
        status: 'Finished',
        startTimestampMs: new Date().getTime(),
      },
      {
        roundId: '2',
        roundNumber: 2,
        cycleNumber: 1,
        status: 'Drafted',
        startTimestampMs: new Date().getTime() + 120 * 1000,
      },
      {
        roundId: '3',
        roundNumber: 3,
        cycleNumber: 1,
        status: 'New',
        startTimestampMs: new Date().getTime() + 120 * 1000,
      },
    ],
    participantsCount: 99,
    delayBetweenRoundsSeconds: 180,
    participationStatus: 'Participating',
    automatedSystemChangeEnabled: false,
    initialFen: null,
    isBlind: false,
    orgSettings: {
      chiefArbiter: null,
      organizer: null,
      arbiters: [],
    },
    joinEligibility: 'Joined',
    removePlayerSetting: 'RemovePlayerAfterTwoNoShows',
  },
  {
    clubId: '200',
    tournamentId: '2',
    title:
      'Отборочный турнир отдела закупок которые никак не могут ничего закупить потому что сломался закупалка',
    status: 'Paused',
    system: 'Swiss',
    swissSettings: {
      roundsCount: 12,
    },
    customRoundDelays: null,
    entrance: 'Invite',
    registrationClosedBeforeStartMinutes: null,
    participantPreModerationEnabled: false,
    rcfRankCalculated: true,
    highlight: 'None',
    mode: 'PrivateTeam',
    clockControl: 'Classic',
    teamsCount: 64,
    teamsCountMax: 64,
    participantsCountMax: null,
    clockControlSettingsPlayer1: {
      initialSeconds: 9999,
      addSecondsPerMove: 9999,
    },
    clockControlSettingsPlayer2: {
      initialSeconds: 9999,
      addSecondsPerMove: 9999,
    },
    additionalScoreOrder: [],
    rulesUrl: '',
    contacts: [],
    startTimestampMs: addHours(Date.now(), -1).getTime(),
    pausedTillTimestampMs: addHours(Date.now(), 1).getTime(),
    rounds: [
      {
        roundId: '1',
        roundNumber: 1,
        cycleNumber: 1,
        status: 'InProgress',
        startTimestampMs: new Date().getTime(),
      },
    ],
    participantsCount: 9999,
    delayBetweenRoundsSeconds: 180,
    participationStatus: 'Invited',
    automatedSystemChangeEnabled: false,
    initialFen: null,
    isBlind: false,
    orgSettings: {
      chiefArbiter: null,
      organizer: null,
      arbiters: [],
    },
    joinEligibility: 'CanJoin',
    removePlayerSetting: 'RemovePlayerAfterTwoNoShows',
  },
  {
    clubId: '200',
    tournamentId: '3',
    title: 'Отборочный турнир отдела закупок. Второй тур.',
    status: 'Finished',
    system: 'Knockout',
    teamsCount: 12,
    teamsCountMax: 64,
    participantsCountMax: 512,
    customRoundDelays: null,
    knockOutSettings: {
      gamesPerRound: 2,
      gamesPerFinalRound: 2,
      draftOrder: 'ByElo',
      maxPartiesCount: null,
      tieSettings: {
        additionalGamesCount: 2,
        additionalGamesFinalCount: 4,
        clockControl: 'Rapid',
        clockControlSettingsPlayer1: {
          initialSeconds: 300,
          addSecondsPerMove: 3,
        },
        clockControlSettingsPlayer2: {
          initialSeconds: 300,
          addSecondsPerMove: 3,
        },
      },
      armageddonSettings: {
        clockControl: 'Rapid',
        clockControlSettingsPlayer1: {
          initialSeconds: 300,
          addSecondsPerMove: 3,
        },
        clockControlSettingsPlayer2: {
          initialSeconds: 300,
          addSecondsPerMove: 3,
        },
      },
    },
    entrance: 'Invite',
    registrationClosedBeforeStartMinutes: null,
    participantPreModerationEnabled: false,
    rcfRankCalculated: true,
    highlight: 'None',
    mode: 'PrivateTeam',
    clockControl: 'Rapid',
    clockControlSettingsPlayer1: {
      initialSeconds: 5,
      addSecondsPerMove: 3,
    },
    clockControlSettingsPlayer2: {
      initialSeconds: 5,
      addSecondsPerMove: 3,
    },
    additionalScoreOrder: ['Berger', 'PartBerger'],
    rulesUrl: '',
    contacts: [],
    startTimestampMs: addHours(Date.now(), -10).getTime(),
    rounds: [],
    participantsCount: 99,
    delayBetweenRoundsSeconds: 180,
    participationStatus: 'Participating',
    automatedSystemChangeEnabled: false,
    initialFen: null,
    isBlind: false,
    participationResultType: 'Place',
    participationResultPlace: '1-3',
    participationResultRating: 1030,
    participationResultRatingChange: 16,
    orgSettings: {
      chiefArbiter: null,
      organizer: null,
      arbiters: [],
    },
    joinEligibility: 'Joined',
    removePlayerSetting: 'RemovePlayerAfterTwoNoShows',
  },
  {
    clubId: '200',
    tournamentId: '4',
    title: 'Отборочный турнир отдела закупок. Третий тур.',
    status: 'Finished',
    system: 'RoundRobin',
    teamsCount: 2,
    teamsCountMax: 64,
    participantsCountMax: 512,
    roundRobinSettings: {
      roundsCount: 2,
      maxPartiesCount: null,
    },
    customRoundDelays: null,
    entrance: 'Rank',
    registrationClosedBeforeStartMinutes: null,
    participantPreModerationEnabled: false,
    rcfRankCalculated: true,
    highlight: 'None',
    mode: 'Team',
    clockControl: 'Classic',
    clockControlSettingsPlayer1: {
      initialSeconds: 60,
      addSecondsPerMove: 60,
    },
    clockControlSettingsPlayer2: {
      initialSeconds: 60,
      addSecondsPerMove: 60,
    },
    additionalScoreOrder: [],
    rulesUrl: '',
    contacts: [],
    startTimestampMs: addHours(Date.now(), -100).getTime(),
    rounds: [],
    participantsCount: 99,
    delayBetweenRoundsSeconds: 180,
    automatedSystemChangeEnabled: false,
    initialFen: null,
    isBlind: false,
    participationResultType: 'Loss',
    participationResultRatingChange: -16,
    orgSettings: {
      chiefArbiter: null,
      organizer: null,
      arbiters: [],
    },
    joinEligibility: 'Joined',
    removePlayerSetting: 'RemovePlayerAfterTwoNoShows',
  },
  {
    clubId: '200',
    tournamentId: '5',
    title: 'Новый турнир',
    status: 'Draft',
    system: 'RoundRobin',
    teamsCount: 64,
    teamsCountMax: 64,
    participantsCountMax: 512,
    roundRobinSettings: {
      roundsCount: 4,
      maxPartiesCount: null,
    },
    customRoundDelays: null,
    entrance: 'Invite',
    registrationClosedBeforeStartMinutes: null,
    participantPreModerationEnabled: false,
    rcfRankCalculated: false,
    highlight: 'None',
    mode: 'Private',
    clockControl: 'Blitz',
    clockControlSettingsPlayer1: {
      initialSeconds: 2,
      addSecondsPerMove: 3,
    },
    clockControlSettingsPlayer2: {
      initialSeconds: 2,
      addSecondsPerMove: 3,
    },
    additionalScoreOrder: [],
    rulesUrl: '',
    contacts: [],
    startTimestampMs: addHours(Date.now(), 2).getTime(),
    rounds: [],
    participantsCount: 99,
    delayBetweenRoundsSeconds: 180,
    participationStatus: 'Invited',
    automatedSystemChangeEnabled: false,
    initialFen: null,
    isBlind: false,
    orgSettings: {
      chiefArbiter: null,
      organizer: null,
      arbiters: [],
    },
    joinEligibility: 'CanJoin',
    removePlayerSetting: 'RemovePlayerAfterTwoNoShows',
  },
  {
    clubId: '200',
    tournamentId: '6',
    title: 'Новый турнир',
    status: 'Draft',
    system: 'RoundRobin',
    teamsCount: 64,
    teamsCountMax: 64,
    participantsCountMax: 512,
    roundRobinSettings: {
      roundsCount: 4,
      maxPartiesCount: null,
    },
    customRoundDelays: null,
    entrance: 'Invite',
    registrationClosedBeforeStartMinutes: null,
    participantPreModerationEnabled: false,
    rcfRankCalculated: false,
    highlight: 'None',
    mode: 'Private',
    clockControl: 'Blitz',
    clockControlSettingsPlayer1: {
      initialSeconds: 2,
      addSecondsPerMove: 3,
    },
    clockControlSettingsPlayer2: {
      initialSeconds: 2,
      addSecondsPerMove: 3,
    },
    additionalScoreOrder: [],
    rulesUrl: '',
    contacts: [],
    rounds: [],
    participantsCount: 99,
    delayBetweenRoundsSeconds: 180,
    participationStatus: 'Banned',
    automatedSystemChangeEnabled: false,
    initialFen: null,
    isBlind: false,
    orgSettings: {
      chiefArbiter: null,
      organizer: null,
      arbiters: [],
    },
    joinEligibility: 'Banned',
    removePlayerSetting: 'RemovePlayerAfterTwoNoShows',
  },
  {
    clubId: '200',
    tournamentId: '7',
    title: 'Сеанс такой-то',
    status: 'Draft',
    system: 'Seance',
    teamsCount: 64,
    teamsCountMax: 64,
    participantsCountMax: 2,
    seanceSettings: {
      maxPlayers: 10,
      seancerSide: 'Both',
      seancer: {
        userId: '1',
        firstName: 'Карп',
        lastName: 'Максимов',
        email: 'k.maximov@test.ru',
        title: 'GM',
        settings: {},
        clubs: [{ clubId: '1', role: 'Member' }],
      },
    },
    customRoundDelays: null,
    entrance: 'Invite',
    registrationClosedBeforeStartMinutes: null,
    participantPreModerationEnabled: false,
    rcfRankCalculated: false,
    highlight: 'None',
    mode: 'Private',
    clockControl: 'Blitz',
    clockControlSettingsPlayer1: {
      initialSeconds: 2,
      addSecondsPerMove: 3,
    },
    clockControlSettingsPlayer2: {
      initialSeconds: 2,
      addSecondsPerMove: 3,
    },
    additionalScoreOrder: [],
    rulesUrl: '',
    contacts: [],
    rounds: [],
    participantsCount: 99,
    delayBetweenRoundsSeconds: 180,
    participationStatus: 'Banned',
    automatedSystemChangeEnabled: false,
    initialFen: null,
    isBlind: false,
    orgSettings: {
      chiefArbiter: null,
      organizer: null,
      arbiters: [],
    },
    joinEligibility: 'Banned',
    removePlayerSetting: 'RemovePlayerAfterTwoNoShows',
  },
];

export const shortTournaments: components['schemas']['TournamentShortDto'][] = gameEvents.map(
  (t) => ({
    ...t,
    startTimestampMs: t.startTimestampMs ?? Date.now(),
    registrationTillTimestampMs: t.registrationTillTimestampMs ?? Date.now(),
    logoUrl: t.logoUrl ?? '',
    swissSettings: {
      roundsCount: 0,
      ...t.swissSettings,
    },
    entranceTicketSets: null,
    participationStatus: 'Participating',
    participationResultType: 'Win',
    participationResultRating: 1050,
    participationResultRatingChange: 15,
    participationResultPlace: '1-3',
    clubEntrance: 'Moderated',
  }),
);

export const clubs: MemberClubDto[] = [
  {
    clubId: '200',
    title: 'Шахматный клуб ОАО «Газпром»',
    description:
      'Armageddon Championship Series: Women’s Week — это&nbsp;захватывающее ежегодное событие для любителей шахмат посвященное выдающимся женщинам в мире шахмат. Мероприятие проходит в живописной Испании и приглашает самых ярких и талантливых шахматисток со всего мира на&nbsp;трехдневные состязания',
    logoUrl: 'https://upload.wikimedia.org/wikipedia/ru/2/2d/Gazprom-Logo-rus.svg',
    membersCount: 3141,
    activeTournamentsCount: 5,
    finishedTournamentsCount: 92,
    createdTimestampMs: new Date('2023-03-02').getTime(),
    administrator: {
      email: 'konst@kos.ru',
      fullName: 'Константин Константинопольский',
      phoneNumber: '99999',
    },
    telegramChannel: '@gazchess',
    themeColor: '#2e4cff',
    moderators: [
      {
        moderatorId: '1',
        email: 'konst@kos.ru',
      },
    ],
    groupTitle: 'ВУЗ',
    entrance: 'Open',
    memberStatus: 'Invited',
    rulesConsentRequired: false,
    rulesConsentGiven: false,
  },
  {
    clubId: '2',
    title: 'РШШ',
    description:
      'Armageddon Championship Series: Women’s Week — это&nbsp;захватывающее ежегодное событие для любителей шахмат посвященное выдающимся женщинам в мире шахмат. Мероприятие проходит в живописной Испании и приглашает самых ярких и талантливых шахматисток со всего мира на&nbsp;трехдневные состязания',
    logoUrl: 'https://upload.wikimedia.org/wikipedia/ru/2/2d/Gazprom-Logo-rus.svg',
    membersCount: 3141,
    activeTournamentsCount: 5,
    finishedTournamentsCount: 92,
    createdTimestampMs: new Date('2023-03-02').getTime(),
    administrator: {
      email: 'konst@kos.ru',
      fullName: 'Константин Константинопольский',
      phoneNumber: '99999',
    },
    telegramChannel: '@gazchess',
    themeColor: '#ff0000',
    moderators: [
      {
        moderatorId: '1',
        email: 'konst@kos.ru',
      },
    ],
    groupTitle: 'ВУЗ',
    entrance: 'Open',
    memberStatus: 'Invited',
    rulesConsentRequired: false,
    rulesConsentGiven: false,
  },
  {
    clubId: '3',
    title: 'Открытый клуб Русской Шахматной Школы. Регулярные турниры',
    description:
      'Armageddon Championship Series: Women’s Week — это&nbsp;захватывающее ежегодное событие для любителей шахмат посвященное выдающимся женщинам в мире шахмат. Мероприятие проходит в живописной Испании и приглашает самых ярких и талантливых шахматисток со всего мира на&nbsp;трехдневные состязания',
    logoUrl: 'https://upload.wikimedia.org/wikipedia/ru/2/2d/Gazprom-Logo-rus.svg',
    membersCount: 3141,
    activeTournamentsCount: 5,
    finishedTournamentsCount: 92,
    createdTimestampMs: new Date('2023-03-02').getTime(),
    administrator: {
      email: 'konst@kos.ru',
      fullName: 'Константин Константинопольский',
      phoneNumber: '99999',
    },
    telegramChannel: '@gazchess',
    themeColor: '#ff0000',
    moderators: [
      {
        moderatorId: '1',
        email: 'konst@kos.ru',
      },
    ],
    groupTitle: 'ВУЗ',
    entrance: 'Open',
    memberStatus: 'Invited',
    rulesConsentRequired: false,
    rulesConsentGiven: false,
  },
];

export const resultsTableAdditionalScores: ResultsTableAdditionalScore[] = [
  {
    scoreType: 'Berger',
    score: 4,
  },
  {
    scoreType: 'PartBerger',
    score: 6.5,
  },
];
export const resultsTableGame: ResultsGame[] = [
  {
    // score: ,
    resultType: 'Skipped',
  },
  {
    score: 1,
    resultType: 'Win',
    side: 'Black',
  },
  {
    score: 0,
    resultType: 'Loss',
    side: 'Black',
  },
  {
    // score: 'С',
    resultType: 'InProgress',
    side: 'Both',
  },
  {
    score: 0.5,
    resultType: 'Draw',
    side: 'White',
  },
  {
    //score: '',
    resultType: 'UnPlayed',
  },
  {
    score: 1,
    resultType: 'Loss',
    side: 'White',
  },
];

export const resultsTablePeople: ResultsTableParticipant[] = [
  {
    no: 1,
    partyId: '1',
    title: 'Константин Константинопольский',
    games: resultsTableGame,
    additionalScores: resultsTableAdditionalScores,
    totalScore: 20,
    place: '2',
    elo: 2412,
  },
  {
    no: 2,
    partyId: '2',
    title: 'Александр Александрийский',
    games: resultsTableGame,
    additionalScores: resultsTableAdditionalScores,
    totalScore: 24.5,
    place: '1',
    elo: 2156,
  },
  {
    no: 3,
    partyId: '3',
    title: 'Петр Петрович',
    games: resultsTableGame,
    additionalScores: resultsTableAdditionalScores,
    totalScore: 10,
    place: '4',
    elo: 1987,
  },
  {
    no: 4,
    partyId: '4',
    title: 'Сергей Сергеин',
    games: resultsTableGame,
    additionalScores: resultsTableAdditionalScores,
    totalScore: 0,
    place: '7',
    elo: 1654,
  },
  {
    no: 5,
    partyId: '5',
    title: 'Пятачок',
    games: resultsTableGame,
    additionalScores: resultsTableAdditionalScores,
    totalScore: 1,
    place: '6',
    elo: 1423,
  },
  {
    no: 6,
    partyId: '6',
    title: 'Винни-пух',
    games: resultsTableGame,
    additionalScores: resultsTableAdditionalScores,
    totalScore: 5,
    place: '5',
    elo: 1245,
  },
  {
    no: 7,
    partyId: '7',
    title: 'Леонид Аркадиевич',
    games: resultsTableGame,
    additionalScores: resultsTableAdditionalScores,
    totalScore: 15,
    place: '3',
    elo: 2089,
  },
];

export const resultsTableRounds: ResultsTableRound[] = [
  {
    num: 1,
    members: resultsTablePeople,
    gamesCount: 7,
    additionalScoreTypes: ['Berger', 'PartBerger'],
  },
  {
    num: 2,
    members: resultsTablePeople,
    gamesCount: 7,
    additionalScoreTypes: ['Berger', 'PartBerger'],
  },
];

export const resultsTableParticipantGroups: ResultsTableParticipant[] = [
  {
    no: 1,
    partyId: '1',
    title: 'Юность Москвы',
    games: resultsTableGame,
    additionalScores: resultsTableAdditionalScores,
    totalScore: 20,
    place: '2',
    subRows: resultsTablePeople,
  },
  {
    no: 2,
    partyId: '2',
    title: 'Дряхлость Омской Области',
    games: resultsTableGame,
    additionalScores: resultsTableAdditionalScores,
    totalScore: 24.5,
    place: '1',
    subRows: resultsTablePeople,
  },
  {
    no: 3,
    partyId: '3',
    title: 'Воронежский Кризис Среднего Возраста',
    games: resultsTableGame,
    additionalScores: resultsTableAdditionalScores,
    totalScore: 10,
    place: '4',
    subRows: resultsTablePeople,
  },
  {
    no: 4,
    partyId: '4',
    title: 'Младенчество Калининград',
    games: resultsTableGame,
    additionalScores: resultsTableAdditionalScores,
    totalScore: 12,
    place: '3',
    subRows: resultsTablePeople,
  },
];

export const groupedResultsTableRounds: ResultsTableRound[] = [
  {
    num: 1,
    members: resultsTableParticipantGroups,
    gamesCount: 7,
    additionalScoreTypes: ['PartBerger', 'Black'],
  },
];

export const resultsTableData: ResultsTableData = {
  rounds: resultsTableRounds,
};

export const resultsTableData2: ResultsTableData = {
  rounds: [...resultsTableRounds, resultsTableRounds[0]!, resultsTableRounds[1]!],
};

export const resultsTableData3: ResultsTableData = {
  rounds: groupedResultsTableRounds,
};

export const roundMovementRows: ParticipantGameMovementRow[] = [
  {
    boardNo: 1,
    player1: {
      firstName: 'Константин',
      lastName: 'Константинопольский',
      title: 'GM',
      userId: '1',
      game: {
        gameId: '1',
        score: 1,
        side: 'White',
        resultType: 'Win',
        cellResult: 'Win',
      },
    },
    player2: {
      firstName: 'Александр',
      lastName: 'Александрийский',
      title: 'IG',
      userId: '2',
      game: {
        gameId: '1',
        score: 0,
        side: 'Black',
        resultType: 'Loss',
        cellResult: 'Loss',
      },
    },
  },
  {
    boardNo: 2,
    player1: {
      firstName: 'Винни',
      lastName: 'Пу',
      title: 'Noob',
      userId: '3',
      game: {
        gameId: '2',
        score: 0.5,
        side: 'Both',
        resultType: 'Draw',
        cellResult: 'Draw',
      },
    },
    player2: {
      firstName: 'Пятачок',
      lastName: 'Просто свинья',
      title: 'Хрюн',
      userId: '4',
      game: {
        gameId: '2',
        score: 0.5,
        side: 'Both',
        resultType: 'Draw',
        cellResult: 'Draw',
      },
    },
  },
];

const knockoutGame1: ResultsGame = {
  gameId: '1',
  score: 1,
  side: 'White',
  resultType: 'Win',
};
const knockoutGame2: ResultsGame = {
  gameId: '2',
  score: 0,
  side: 'Black',
  resultType: 'Loss',
};
const knockoutPlayer1 = {
  userId: '1',
  lastName: 'Константинопольский',
  firstName: 'Константин',
};
const knockoutPlayer2 = {
  userId: '2',
  firstName: 'Вася',
  lastName: 'Пупкин',
};
const knockoutTotal1: KnockoutResultsPlayer['total'] = {
  score: '2.5',
  resultType: 'Win',
};
const knockoutTotal2: KnockoutResultsPlayer['total'] = {
  score: '1',
  resultType: 'Loss',
};
const knockoutMatch1: KnockoutResultsMatch = {
  player1: {
    ...knockoutPlayer1,
    total: knockoutTotal1,
    games: [knockoutGame1],
  },
  player2: {
    ...knockoutPlayer2,
    total: knockoutTotal2,
    games: [knockoutGame2],
  },
};
const knockoutMatch2: KnockoutResultsMatch = {
  player1: {
    ...knockoutPlayer1,
    total: knockoutTotal1,
    games: [knockoutGame1, knockoutGame2],
  },
  player2: {
    ...knockoutPlayer2,
    total: knockoutTotal2,
    games: [knockoutGame2, knockoutGame1],
  },
};
const knockoutMatchBye: KnockoutResultsMatch = {
  player1: {
    ...knockoutPlayer1,
    total: { score: '', resultType: 'UnPlayed' },
    games: [],
  },
};
const knockoutMatchFinal: KnockoutResultsMatch = {
  player1: {
    ...knockoutPlayer1,
    total: knockoutTotal1,
    games: [knockoutGame1],
  },
  player2: {
    ...knockoutPlayer2,
    total: knockoutTotal2,
    games: [knockoutGame2],
  },
};

export const knockoutResultsData: KnockoutResults = {
  rounds: [
    {
      roundId: '1',
      roundName: '32',
      roundType: 'WinnerBranch',
      matches: [knockoutMatch1, knockoutMatch2, knockoutMatch1, knockoutMatch2, knockoutMatchBye],
    },
    {
      roundId: '2',
      roundName: '16',
      roundType: 'WinnerBranch',
      matches: [knockoutMatch1, knockoutMatch2, knockoutMatchBye],
    },
    {
      roundId: '3',
      roundName: '2',
      roundType: 'WinnerBranch',
      matches: [knockoutMatch1, knockoutMatchBye],
    },
    {
      roundId: '4',
      roundName: '3e место',
      roundType: 'ThirdPlace',
      matches: [knockoutMatch1],
    },
    {
      roundId: '5',
      roundName: '1',
      roundType: 'Final',
      matches: [knockoutMatchFinal],
    },
  ],
};

const knockoutTeam1 = {
  userId: '',
  lastName: '',
  firstName: 'Константиновские',
};
const knockoutTeam2 = {
  userId: '',
  firstName: 'Пупкины',
  lastName: '',
};
const knockoutTeamMatch1: KnockoutResultsMatch = {
  player1: {
    ...knockoutTeam1,
    total: knockoutTotal1,
    games: [knockoutGame1],
    subRows: [
      {
        ...knockoutPlayer1,
        total: knockoutTotal1,
        games: [knockoutGame1],
      },
    ],
  },
  player2: {
    ...knockoutTeam2,
    total: knockoutTotal2,
    games: [knockoutGame2],
    subRows: [
      {
        ...knockoutTeam2,
        total: knockoutTotal2,
        games: [knockoutGame2],
      },
    ],
  },
};
const knockoutTeamMatch2: KnockoutResultsMatch = {
  player1: {
    ...knockoutTeam1,
    total: knockoutTotal1,
    games: [knockoutGame1, knockoutGame2],
    subRows: [
      {
        ...knockoutPlayer1,
        total: knockoutTotal1,
        games: [knockoutGame1, knockoutGame2],
      },
    ],
  },
  player2: {
    ...knockoutTeam2,
    total: knockoutTotal2,
    games: [knockoutGame2, knockoutGame1],
    subRows: [
      {
        ...knockoutPlayer2,
        total: knockoutTotal2,
        games: [knockoutGame2, knockoutGame1],
      },
    ],
  },
};
const knockoutTeamMatchBye: KnockoutResultsMatch = {
  player1: {
    ...knockoutTeam1,
    total: { score: '', resultType: 'UnPlayed' },
    games: [],
    subRows: [
      {
        ...knockoutPlayer1,
        total: { score: '', resultType: 'UnPlayed' },
        games: [],
      },
    ],
  },
};
const knockoutTeamMatchFinal: KnockoutResultsMatch = {
  player1: {
    ...knockoutTeam1,
    total: knockoutTotal1,
    games: [knockoutGame1],
    subRows: [
      {
        ...knockoutPlayer1,
        total: knockoutTotal1,
        games: [knockoutGame1],
      },
    ],
  },
  player2: {
    ...knockoutTeam2,
    total: knockoutTotal2,
    games: [knockoutGame2],
    subRows: [
      {
        ...knockoutPlayer2,
        total: knockoutTotal2,
        games: [knockoutGame2],
      },
    ],
  },
};

export const knockoutTeamResultsData: KnockoutResults = {
  rounds: [
    {
      roundId: '1',
      roundName: '32',
      roundType: 'WinnerBranch',
      matches: [
        knockoutTeamMatch1,
        knockoutTeamMatch2,
        knockoutTeamMatch1,
        knockoutTeamMatch2,
        knockoutTeamMatchBye,
      ],
    },
    {
      roundId: '2',
      roundName: '16',
      roundType: 'WinnerBranch',
      matches: [knockoutTeamMatch1, knockoutTeamMatch2, knockoutTeamMatchBye],
    },
    {
      roundId: '3',
      roundName: '2',
      roundType: 'WinnerBranch',
      matches: [knockoutTeamMatch1, knockoutTeamMatchBye],
    },
    {
      roundId: '4',
      roundName: 'третье место',
      roundType: 'ThirdPlace',
      matches: [knockoutTeamMatch1],
    },
    {
      roundId: '5',
      roundName: '1',
      roundType: 'Final',
      matches: [knockoutTeamMatchFinal],
    },
  ],
};

export const clubMyStats: MyClubStatsType = {
  blitz: {
    clockControlType: 'Blitz',
    clubRank: 999,
    gamesCount: 40,
    winCount: 20,
    drawCount: 10,
  },
  rapid: {
    clockControlType: 'Rapid',
    clubRank: 1,
    gamesCount: 60,
    winCount: 20,
    drawCount: 15,
  },
  classic: {
    clockControlType: 'Classic',
    clubRank: 55,
    gamesCount: 0,
    winCount: 0,
    drawCount: 0,
  },
  winsAsBlackCount: 30,
  winsAsWhiteCount: 10,
  totalGamesCount: 100,
  totalTournamentsCount: 10,
  totalWinCount: 40,
  recentGames: [
    {
      tournamentId: '1',
      gameId: '1',
      fen: FEN_SPECIAL_WHITE_WIN,
      mySide: 'White',
      whitePlayer: {
        userId: '1',
        name: 'Константин Константинопольский',
        score: 1,
      },
      blackPlayer: { userId: '2', name: 'Василий Иванович', score: 0 },
      result: 'WhiteWin',
    },
    {
      tournamentId: '1',
      gameId: '2',
      fen: FEN_SPECIAL_WHITE_WIN,
      mySide: 'Black',
      whitePlayer: { userId: '3', name: 'Макар Андреевич', score: 1 },
      blackPlayer: {
        userId: '1',
        name: 'Константин Константинопольский',
        score: 0,
      },
      result: 'WhiteWin',
    },
    {
      tournamentId: '1',
      gameId: '3',
      fen: FEN_SPECIAL_DRAW,
      mySide: 'White',
      whitePlayer: {
        userId: '1',
        name: 'Константин Константинопольский',
        score: 0.5,
      },
      blackPlayer: { userId: '4', name: 'Винни Пух', score: 0.5 },
      result: 'Draw',
    },
  ],
};

const BIG_DESCRIPTION =
  'Власти Афганистана запретили шахматы на территории страны из-за того, что они могут быть азартной игрой. Глава FIDE Дворкович заявил, что проблемы в местной шахматной федерации нужно решать в любом случае\n' +
  '\n' +
  'Международная федерация (FIDE) будет вести консультации с целью «восстановить шахматную жизнь» в Афганистане, заявил «РИА Новости» президент организации Аркадий Дворкович.\n' +
  '\n' +
  '«В местной федерации шахмат было много проблем, которые необходимо решать в любом случае», — отметил Дворкович.\n' +
  'Накануне стало известно, что власти Афганистана запретили игру в шахматы на всей территории страны до дальнейшего уведомления. Как сообщил AFP представитель спортивного директората Атал Машвани, «шахматы в шариате считаются азартной игрой», а это запрещено принятым в прошлом году законом «О распространении добродетели и предотвращении порока».\n' +
  '\n' +
  'По словам Машвани, к шахматам есть вопросы с точки зрения религии и до их решения игра будет запрещена.\n' +
  'Машвани добавил, что национальная шахматная федерация не проводила никаких официальных мероприятий около двух лет и «имела некоторые проблемы на уровне руководства».\n' +
  '\n' +
  'В прошлом году в Афганистане запретили профессиональные поединки по смешанным единоборствам (ММА) из-за их «жестокости» и «проблемности с точки зрения шариата», а женщинам, по сути, вообще не разрешается заниматься спортом, отмечает агентство.\n' +
  '\n' +
  'У власти в Афганистане с 2021 года находится движение «Талибан», которое Верховный суд России в апреле 2025-го постановил исключить из списка террористических организаций.';

export const news: NewsPost[] = [
  {
    id: '1',
    title: 'Прошло официальное награждение победителей детского чемпионата 2025',
    promoted: true,
    publishTimestampMs: new Date().getTime(),
    text: BIG_DESCRIPTION,
  },
  {
    id: '2',
    title: 'Шахматы в баре пройдут 12 декабря, вход для участников клуба свободный',
    promoted: false,
    publishTimestampMs: new Date().getTime(),
    text: BIG_DESCRIPTION,
  },
  {
    id: '3',
    title: 'Дворкович заявил о цели восстановить шахматную жизнь в Афганистане',
    promoted: false,
    publishTimestampMs: new Date().getTime(),
    text: BIG_DESCRIPTION,
  },
  {
    id: '4',
    title: 'Этому не учат в школе: как развить критическое мышление у ребенка',
    promoted: false,
    publishTimestampMs: new Date().getTime(),
    text: BIG_DESCRIPTION,
  },
  {
    id: '5',
    title: 'Сервис Duolingo планирует запустить курс по обучению игры в шахматы',
    promoted: false,
    publishTimestampMs: new Date().getTime(),
    text: BIG_DESCRIPTION,
  },
];

export const winners: Winner[] = [
  {
    tournamentId: '1',
    winnerTitles: ['Константин Константинопольский'],
    tournamentTitle: 'Турнир чемпионов второго года работы: Юноши',
  },
  {
    tournamentId: '2',
    winnerTitles: ['Команда МФТИ'],
    tournamentTitle: 'Осенний турнир сотрудников',
  },
  {
    tournamentId: '3',
    winnerTitles: ['Антон Шаповал'],
    tournamentTitle: 'Отборочный турнир отдела закупок',
  },
  {
    tournamentId: '4',
    winnerTitles: ['Николай Николаенко'],
    tournamentTitle: 'Турнир Газпромбанка',
  },
  {
    tournamentId: '5',
    winnerTitles: ['Ян Ким'],
    tournamentTitle: 'Отборочный турнир отдела закупок',
  },
  {
    tournamentId: '6',
    winnerTitles: ['А. А. Лебедев'],
    tournamentTitle: 'Турнир Газпромбанка',
  },
];

export const topPlayers: TopPlayer[] = members.map((member, i) => ({
  clubRank: i + 1,
  clubRating: member.clubElo.blitz.rating,
  member,
  gamesCount: member.gamesCount,
  winsCount: Math.floor(member.gamesCount / 2),
}));

export const sponsors: Sponsor[] = [
  {
    number: 1,
    caption: 'Синергия',
    logoUri: 'https://www.ptrg.ru/medal/images/stories/fotoznakivuz/sinertgija/photo-1.jpg',
    text: 'Лучший спонсор всех времен - концерн Синергия',
  },
  {
    number: 2,
    logoUri: 'https://hobbygames.ru/assets/img/svg/logo.svg',
    linkUri: 'http://t.me/test',
  },
  {
    number: 3,
    logoUri: 'https://upload.wikimedia.org/wikipedia/ru/2/2d/Gazprom-Logo-rus.svg',
    caption: 'GazProm',
  },
];

export const playerStats: PlayerStats[] = [
  {
    firstName: 'Константин',
    lastName: 'Константинопольский',
    avatarSrc: undefined,
    totalGamesCount: 999999,
    totalTournamentsCount: 9999,
    totalWinCount: 555111,
    stamina: 500,
    experience: 232,
    rate: 1020,
    tactics: 325,
    totalRate: 1010,
    efficiency: 32,
  },
  {
    firstName: 'Константин',
    lastName: 'Константинопольский',
    avatarSrc: undefined,
    totalGamesCount: 0,
    totalTournamentsCount: 0,
    totalWinCount: 0,
    stamina: 0,
    experience: 2,
    rate: 0,
    tactics: 0,
    totalRate: 0,
    efficiency: 0,
  },
  {
    firstName: 'Константин',
    lastName: 'Константинопольский',
    avatarSrc: undefined,
    totalGamesCount: 115,
    totalTournamentsCount: 999,
    totalWinCount: 42,
    stamina: 500,
    experience: 232,
    rate: 1020,
    tactics: 999,
    totalRate: 1010,
    efficiency: 32,
  },
];

export const playerEloStats: PlayerEloStats = {
  blitz: {
    clockControl: 'Blitz',
    gamesCount: 100500,
    rating: 12000,
    lastChange: -45,
  },
  rapid: {
    clockControl: 'Rapid',
    gamesCount: 46,
    rating: 1000,
    lastChange: 400,
  },
  classic: {
    clockControl: 'Classic',
    gamesCount: 46,
    rating: 980,
    lastChange: 1,
  },
};

export const users: User[] = [
  {
    userId: '1',
    firstName: 'Константин',
    lastName: 'Константинопольский',
    avatarSrc: '/stubs/natalie.png',
    clubs: [
      { clubId: clubs[0]!.clubId, role: 'Member' },
      { clubId: clubs[1]!.clubId, role: 'Member' },
    ],
  },
  {
    userId: '2',
    firstName: 'Константин',
    lastName: 'Константинопольский',
    clubs: [
      { clubId: clubs[0]!.clubId, role: 'Member' },
      { clubId: clubs[1]!.clubId, role: 'Member' },
    ],
  },
];

export const linearChartPoints: ChartPoint[] = [
  {
    x: new Date('2023-04-01').getTime(),
    y: 0,
    label: 0,
  },
  {
    x: new Date('2023-04-02').getTime(),
    y: 15,
    label: 15,
  },
  {
    x: new Date('2023-04-03').getTime(),
    y: 5,
    label: 5,
  },
  {
    x: new Date('2023-04-04').getTime(),
    y: 10,
    label: 10,
  },
  {
    x: new Date('2023-04-05').getTime(),
    y: 20,
    label: 20,
  },
  {
    x: new Date('2023-04-01').getTime(),
    y: 0,
    label: 0,
  },
  {
    x: new Date('2023-04-02').getTime(),
    y: 15,
    label: 15,
  },
  {
    x: new Date('2023-04-03').getTime(),
    y: 5,
    label: 5,
  },
  {
    x: new Date('2023-04-04').getTime(),
    y: 10,
    label: 10,
  },
  {
    x: new Date('2023-04-05').getTime(),
    y: 20,
    label: 20,
  },
];

export const emptyLinearChartPoints: ChartPoint[] = [
  { x: 0, y: 0, label: 0 },
  { x: 1, y: 0, label: 0 },
  { x: 2, y: 0, label: 0 },
  { x: 3, y: 0, label: 0 },
  { x: 4, y: 0, label: 0 },
  { x: 5, y: 0, label: 0 },
  { x: 6, y: 0, label: 0 },
];

export const historyGames: components['schemas']['UserGameHistoryItemDto'][] = [
  {
    id: '1',
    gameId: '1',
    gameSource: 'Tournament',
    gameStartTimeStamp: new Date().getTime(),
    userId: '1',
    opponentUserId: '2',
    opponentFirstName: 'Константин',
    opponentLastName: 'Константинопольский',
    clubId: '200',
    tournamentId: '1',
    tournamentTitle: 'Веселые Истории в Журнале',
    eloType: 'Global',
    clockControlType: 'Rapid',
    previousElo: 1023,
    eloChange: 13,
    newElo: 1036,
    timeStamp: new Date().getTime(),
    result: 'Win',
  },
  {
    id: '2',
    gameId: '2',
    gameSource: 'Tournament',
    gameStartTimeStamp: new Date().getTime(),
    userId: '1',
    opponentUserId: '2',
    opponentFirstName: 'Артем',
    opponentLastName: 'Ким',
    clubId: '200',
    tournamentId: '1',
    tournamentTitle: 'Веселые Истории в Журнале',
    eloType: 'Global',
    clockControlType: 'Rapid',
    previousElo: 1023,
    eloChange: -13,
    newElo: 1010,
    timeStamp: new Date().getTime(),
    result: 'Loss',
  },
  {
    id: '3',
    gameId: '3',
    gameSource: 'Tournament',
    // UTC check
    gameStartTimeStamp: new Date(addHours(startOfYesterday(), 3)).getTime(),
    userId: '1',
    opponentUserId: '2',
    opponentFirstName: 'Анатолий',
    opponentLastName: 'Арсеньев',
    clubId: '200',
    tournamentId: '1',
    tournamentTitle: 'Веселые Истории в Журнале',
    eloType: 'Global',
    clockControlType: 'Rapid',
    previousElo: 1023,
    eloChange: 0,
    newElo: 1023,
    timeStamp: new Date().getTime(),
    result: 'Draw',
  },
  {
    id: '4',
    gameId: '4',
    gameSource: 'Tournament',
    gameStartTimeStamp: startOfYesterday().getTime(),
    userId: '1',
    opponentUserId: '2',
    opponentFirstName: 'Магнус',
    opponentLastName: 'Карлсон',
    clubId: '200',
    tournamentId: '1',
    tournamentTitle: 'Веселые Истории в Журнале',
    eloType: 'Global',
    clockControlType: 'Rapid',
    previousElo: 1023,
    eloChange: 120,
    newElo: 1143,
    timeStamp: new Date().getTime(),
    result: 'Win',
  },
  {
    id: '5',
    gameId: '5',
    gameSource: 'Tournament',
    gameStartTimeStamp: startOfYesterday().getTime(),
    userId: '1',
    opponentUserId: '2',
    opponentFirstName: 'Федор',
    opponentLastName: 'Николаенко',
    clubId: '200',
    tournamentId: '1',
    tournamentTitle: 'Веселые Истории в Журнале',
    eloType: 'Global',
    clockControlType: 'Rapid',
    previousElo: 1223,
    eloChange: -120,
    newElo: 1103,
    timeStamp: new Date().getTime(),
    result: 'Loss',
  },
  {
    id: '6',
    gameId: '6',
    gameSource: 'Tournament',
    gameStartTimeStamp: subDays(new Date(), 2).getTime(),
    userId: '1',
    opponentUserId: '2',
    opponentFirstName: 'Юрий',
    opponentLastName: 'Останкинский',
    clubId: '200',
    tournamentId: '1',
    tournamentTitle: 'Веселые Истории в Журнале',
    eloType: 'Global',
    clockControlType: 'Rapid',
    previousElo: 1023,
    eloChange: 13,
    newElo: 1036,
    timeStamp: new Date().getTime(),
    result: 'Win',
  },
  {
    id: '7',
    gameId: '7',
    gameSource: 'Tournament',
    gameStartTimeStamp: subDays(new Date(), 2).getTime(),
    userId: '1',
    opponentUserId: '2',
    opponentFirstName: 'Эдуард',
    opponentLastName: 'Эбергард',
    clubId: '200',
    tournamentId: '1',
    tournamentTitle: 'Веселые Истории в Журнале',
    eloType: 'Global',
    clockControlType: 'Rapid',
    previousElo: 1023,
    eloChange: 0,
    newElo: 1023,
    timeStamp: new Date().getTime(),
    result: 'Draw',
  },
  {
    id: '8',
    gameId: '8',
    gameSource: 'Tournament',
    gameStartTimeStamp: subDays(new Date(), 2).getTime(),
    userId: '1',
    opponentUserId: '2',
    opponentFirstName: 'Олег',
    opponentLastName: 'Якименко',
    clubId: '200',
    tournamentId: '1',
    tournamentTitle: 'Веселые Истории в Журнале',
    eloType: 'Global',
    clockControlType: 'Rapid',
    previousElo: 1023,
    eloChange: 13,
    newElo: 1036,
    timeStamp: new Date().getTime(),
    result: 'Win',
  },
  {
    id: '9',
    gameId: '9',
    gameSource: 'Tournament',
    gameStartTimeStamp: subDays(new Date(), 100).getTime(),
    userId: '1',
    opponentUserId: '2',
    opponentFirstName: 'Игорь',
    opponentLastName: 'Долвич',
    clubId: '200',
    tournamentId: '1',
    tournamentTitle: 'Веселые Истории в Журнале',
    eloType: 'Global',
    clockControlType: 'Rapid',
    previousElo: 1023,
    eloChange: 13,
    newElo: 1036,
    timeStamp: new Date().getTime(),
    result: 'Win',
  },
  {
    id: '10',
    gameId: '10',
    gameSource: 'Tournament',
    gameStartTimeStamp: subDays(new Date(), 300).getTime(),
    userId: '1',
    opponentUserId: '2',
    opponentFirstName: 'Ваня',
    opponentLastName: 'Долвич',
    clubId: '200',
    tournamentId: '1',
    tournamentTitle: 'Веселые Истории в Журнале',
    eloType: 'Global',
    clockControlType: 'Rapid',
    previousElo: 1023,
    eloChange: 13,
    newElo: 1036,
    timeStamp: new Date().getTime(),
    result: 'Win',
  },
];

export const achievements: Achievement[] = [
  {
    type: 'TournamentCertificate',
    receiveTimestampMs: new Date().getTime(),
    tournamentCertificate: {
      tournamentId: '1',
      clubId: '1',
      tournamentTitle: 'Командный чемпионат НСШЛ. ЮФО. Матч за первое место',
      downloadLink: 'http://localhost:5173/stubs/Сертификат.pdf',
      place: '1',
      svgSrc: 'http://localhost:5173/stubs/svg/certificate_blitz.svg',
      svgTemplateSrc: 'http://localhost:5173/stubs/svg/certificate_blitz.svg',
      fields: {},
    },
  },
  {
    type: 'TournamentCertificate',
    receiveTimestampMs: new Date().getTime(),
    tournamentCertificate: {
      tournamentId: '2',
      clubId: '1',
      tournamentTitle: 'Раскидали вечером с пацанами партейку',
      downloadLink: 'http://localhost:5173/stubs/Сертификат.pdf',
      place: '4',
      svgSrc: 'http://localhost:5173/stubs/svg/certificate_blitz.svg',
      svgTemplateSrc: 'http://localhost:5173/stubs/svg/certificate_blitz.svg',
      fields: {},
    },
  },
  {
    type: 'TournamentCertificate',
    receiveTimestampMs: new Date().getTime(),
    tournamentCertificate: {
      tournamentId: '3',
      clubId: '1',
      tournamentTitle: 'РШШ Open Weeks 2024',
      downloadLink: 'http://localhost:5173/stubs/Сертификат.pdf',
      place: '10',
      svgSrc: 'http://localhost:5173/stubs/svg/certificate_blitz.svg',
      svgTemplateSrc: 'http://localhost:5173/stubs/svg/certificate_blitz.svg',
      fields: {},
    },
  },
  {
    type: 'TournamentCertificate',
    receiveTimestampMs: new Date().getTime(),
    tournamentCertificate: {
      tournamentId: '4',
      clubId: '1',
      tournamentTitle: 'World Chess ChampionShip, Dubai, first round',
      downloadLink: 'http://localhost:5173/stubs/Сертификат.pdf',
      place: '1',
      svgSrc: 'http://localhost:5173/stubs/svg/certificate_blitz.svg',
      svgTemplateSrc: 'http://localhost:5173/stubs/svg/certificate_blitz.svg',
      fields: {},
    },
  },
  {
    type: 'TournamentCertificate',
    receiveTimestampMs: new Date().getTime(),
    tournamentCertificate: {
      tournamentId: '5',
      clubId: '1',
      tournamentTitle: 'Командный чемпионат НСШЛ. ЮФО. Матч за первое место',
      downloadLink: 'http://localhost:5173/stubs/Сертификат.pdf',
      place: '1',
      svgSrc: 'http://localhost:5173/stubs/svg/certificate_blitz.svg',
      svgTemplateSrc: 'http://localhost:5173/stubs/svg/certificate_blitz.svg',
      fields: {},
    },
  },
  {
    type: 'TournamentCertificate',
    receiveTimestampMs: new Date().getTime(),
    tournamentCertificate: {
      tournamentId: '6',
      clubId: '1',
      tournamentTitle: 'World Chess ChampionShip, Dubai, first round',
      downloadLink: 'http://localhost:5173/stubs/Сертификат.pdf',
      place: '1',
      svgSrc: 'http://localhost:5173/stubs/svg/certificate_blitz.svg',
      svgTemplateSrc: 'http://localhost:5173/stubs/svg/certificate_blitz.svg',
      fields: {},
    },
  },

  {
    type: 'TournamentCertificate',
    receiveTimestampMs: new Date().getTime(),
    tournamentCertificate: {
      tournamentId: '7',
      clubId: '1',
      tournamentTitle: 'Раскидали вечером с пацанами партейку',
      downloadLink: 'http://localhost:5173/stubs/Сертификат.pdf',
      place: '1',
      svgSrc: 'http://localhost:5173/stubs/svg/certificate_blitz.svg',
      svgTemplateSrc: 'http://localhost:5173/stubs/svg/certificate_blitz.svg',
      fields: {},
    },
  },

  {
    type: 'TournamentCertificate',
    receiveTimestampMs: new Date().getTime(),
    tournamentCertificate: {
      tournamentId: '8',
      clubId: '1',
      tournamentTitle: 'РШШ Open Weeks 2024',
      downloadLink: 'http://localhost:5173/stubs/Сертификат.pdf',
      place: '1',
      svgSrc: 'http://localhost:5173/stubs/svg/certificate_blitz.svg',
      svgTemplateSrc: 'http://localhost:5173/stubs/svg/certificate_blitz.svg',
      fields: {},
    },
  },
  {
    type: 'TournamentCertificate',
    receiveTimestampMs: new Date().getTime(),
    tournamentCertificate: {
      tournamentId: '9',
      clubId: '1',
      tournamentTitle: 'World Chess ChampionShip, Dubai, first round',
      downloadLink: 'http://localhost:5173/stubs/Сертификат.pdf',
      place: '1',
      svgSrc: 'http://localhost:5173/stubs/svg/certificate_blitz.svg',
      svgTemplateSrc: 'http://localhost:5173/stubs/svg/certificate_blitz.svg',
      fields: {},
    },
  },

  {
    type: 'TournamentCertificate',
    receiveTimestampMs: new Date().getTime(),
    tournamentCertificate: {
      tournamentId: '10',
      clubId: '1',
      tournamentTitle: 'World Chess ChampionShip, Dubai, first round',
      downloadLink: 'http://localhost:5173/stubs/Сертификат.pdf',
      place: '1',
      svgSrc: 'http://localhost:5173/stubs/svg/certificate_blitz.svg',
      svgTemplateSrc: 'http://localhost:5173/stubs/svg/certificate_blitz.svg',
      fields: {},
    },
  },
];

export const publicTournaments: publicComponents['schemas']['TournamentPublicDto'][] =
  shortTournaments.map((t) => ({
    id: t.tournamentId,
    ...t,
    clockControlSettings: t.clockControlSettings!,
    clubTitle: clubs[0]!.title,
    clubEntrance: clubs[0]!.entrance,
    clubLogoUrl: clubs[0]!.logoUrl,
  }));
